import React from 'react'

import { cn } from '~/styled'

import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'

const getBarWidth = (rowIndex: number) =>
  Math.round(40 + Math.abs(Math.sin(rowIndex + 1)) * 55)

const LegendItem = () => (
  <div className="flex items-center gap-2">
    <SkeletonLoader className="h-3 w-3 rounded-full" />
    <SkeletonLoader className="h-3 w-24 rounded-full" />
  </div>
)

export const SkeletonBarChart = ({
  numberOfLabels = 3,
  numberOfRows = 4,
  numberOfTicks = 4,
  className
}: {
  numberOfLabels?: number
  numberOfRows?: number
  numberOfTicks?: number
  className?: string
}) => (
  <Tile className={cn('p-6', 'flex-col', 'gap-6', 'w-full', className)}>
    <div className="flex items-center gap-4">
      {Array.from({ length: numberOfLabels }, (_, i) => (
        <LegendItem key={i} />
      ))}
    </div>
    <div className="flex flex-col justify-between gap-4">
      {Array.from({ length: numberOfRows }, (_, i) => (
        <div key={i} className="flex items-center gap-5">
          <SkeletonLoader className="h-3 w-20 shrink-0 rounded-full" />
          <div className="grow">
            <SkeletonLoader
              className="h-5 w-(--width) rounded-full"
              style={{
                '--width': `${getBarWidth(i)}%`
              }}
            />
          </div>
        </div>
      ))}
      <div className="flex justify-between pl-24">
        {Array.from({ length: numberOfTicks }, (_, i) => (
          <SkeletonLoader key={i} className="h-2 w-8 rounded-full" />
        ))}
      </div>
    </div>
  </Tile>
)
